export default "__VITE_ASSET__ti$msBf1__"